
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","fill":"none"}},[_c('rect',{attrs:{"width":"33","height":"33","x":".5","y":".5","stroke":"#DDD","rx":"3.5"}}),_c('path',{attrs:{"fill":"#fff","d":"M5 5h24v24H5z"}}),_c('path',{attrs:{"fill":"#072521","fill-rule":"evenodd","d":"M22.85 12.564a1 1 0 00-1.414-1.414L17 15.586l-4.435-4.436a1 1 0 00-1.415 1.414L15.586 17l-4.436 4.436a1 1 0 001.415 1.414L17 18.414l4.436 4.436a1 1 0 001.414-1.415L18.414 17l4.436-4.436z","clip-rule":"evenodd"}})])
      }
    
      }
    